<div class="flex-column align-items-center">
  <!-- Title and directions -->
  <span matDialogTitle>Merge Assets</span>
  <p class="directions">Both Assets' transaction data, history, attachments, groups, and photos will be combined. Select which values you would like the new merged asset to have.</p>
  <!-- grey/opaque section for asset info & comparison -->
  <div class="flex-column comparison-container">

    <!-- loop through assets' differences and show a dual-input for each -->
    <div class="gap-10" [formGroup]="assetForm" [ngClass]="{'margin-update': combineAsset.length > 2}">
      <!-- asset names + pictures -->
      <div class="flex justify-space-around">
        @for (asset of combineAsset; track asset) {
          <div class="flex-column gap-10">
            <p class="p-spacing">{{asset.name}}</p>
            @if (asset?.photos && asset?.photos.length) {
              <img
                class="asset-thumbnail-image"
                src="{{asset?.photos[0]?.links.thumbnail}}">
            }
          </div>
        }
      </div>
      <!--  created at, last modified -->
      <div class="flex justify-space-around">
        @for (asset of combineAsset; track asset) {
          <div class="flex-column gap-10">
            <p class="p-spacing">Created {{moment.utc(asset.created_at).local().format('MMM D, YYYY')}}</p>
            <p>Last Updated {{moment.utc(asset.updated_at).local().format('MMM D, YYYY')}}</p>
          </div>
        }
      </div>
      @for (field of (showAllFields ? allFields : fieldsWithDifferentValues); track field) {
        <ah-dual-input
          [group]="assetForm"
          [field]="field"
          [allFields]="allFields"
          [combineAsset]="combineAsset"
          (radioClick)="onSelectControl($event)"
          (changeLeft)="onSelectControl($event)"
          (changeRight)="onSelectControl($event)"
          (changeThird)="onSelectControl($event)"
          (changeFourth)="onSelectControl($event)"
          (changeFifth)="onSelectControl($event)"
        ></ah-dual-input>
      }
    </div>
  </div>
  <!-- field toggle function -->
  @if (!showAllFields) {
    <div style="padding-top: 10px;">
      <span>Showing fields with different values</span>
      <div class="link" (click)="onShowAllFields()">Show All Fields</div>
    </div>
  }
  @if (showAllFields) {
    <div style="padding-top: 10px;">
      <span>Showing all fields</span>
      <div class="link" (click)="onShowLessFields()">Show Less Fields</div>
    </div>
  }
  <!-- button container -->
  <div class="flex justify-space-between" style="width: 95%;">
    <div class="left-spacer"></div>
    
    <div class="justify-content-center justify-flex-end" style="width: 40%;">
      @for (item of savingMessage; track item) {
      <p-message class="saving-message" [severity]="item.severity">{{item.summary}}</p-message>
      }      
    </div>
    <div class="flex gap-20 button-container">
      <button mat-raised-button matDialogClose [disabled]="saving" class="button-padding">Cancel</button>
      <button mat-raised-button color="primary" (click)="onMergeAssets()" [disabled]="saving" class="save-button-padding">Merge</button>
    </div>
  </div>
</div>
